import styled from 'styled-components'

export const ColumnViewWrapper = styled('div')`
  height: calc(100vh - 80px - 90px - 60px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const NavigationBar = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid #dee2e6;
`

export const GridScrollContainer = styled('div')`
  flex: 1;
  overflow: auto;
  position: relative;
`

export const GridTable = styled('div')<{ columns: number; rows: number }>`
  display: grid;
  grid-template-columns: 60px repeat(${({ columns }) => columns}, minmax(200px, 1fr));
  grid-template-rows: auto auto repeat(${({ rows }) => rows}, 1fr);
  min-width: fit-content;
  width: 100%;
  height: 100%;
`

export const DateHeaderCell = styled('div')<{ span: number; color?: string; isToday?: boolean }>`
  grid-column: span ${({ span }) => span};
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  padding: 10px 4px;
  border-bottom: 2px solid #e2e8f0;
  border-right: 3px solid #cbd5e1;
  background: ${({ isToday }) => isToday ? '#e0e7ff' : '#f8fafc'};
  color: ${({ isToday }) => isToday ? '#3730a3' : '#334155'};
`

export const DoctorHeaderCell = styled('div')<{ bgColor?: string; isLastInDay?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 6px;
  border-bottom: 1px solid #e2e8f0;
  border-right: ${({ isLastInDay, bgColor }) => isLastInDay ? '3px solid #cbd5e1' : `2px solid ${bgColor || 'rgba(255,255,255,0.35)'}`};
  color: #fff;
  background: ${({ bgColor }) => bgColor || '#818cf8'};
  border-radius: 10px 10px 0 0;
  overflow: hidden;
`

export const DoctorAvatar = styled('img')`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`

export const DoctorAvatarPlaceholder = styled('div')`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
  flex-shrink: 0;
`

export const DoctorName = styled('span')`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  text-align: center;
  line-height: 1.3;
`

export const TimeCell = styled('div')`
  position: sticky;
  left: 0;
  z-index: 2;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  border-bottom: 2px solid #e2e8f0;
  font-size: 12px;
  color: #64748b;
  padding: 2px 8px 0 0;
  text-align: right;
  box-sizing: border-box;
`

export const BodyCell = styled('div')<{ isLastInDay?: boolean; borderColor?: string; isToday?: boolean }>`
  position: relative;
  border-right: ${({ isLastInDay, borderColor }) => isLastInDay ? '3px solid #cbd5e1' : `2px solid ${borderColor || '#f1f5f9'}`};
  border-bottom: 2px solid #e2e8f0;
  box-sizing: border-box;
  cursor: pointer;
  background: ${({ isToday }) => isToday ? '#f5f3ff' : 'transparent'};

  &:hover {
    background: #f0f4ff;
  }
`

export const AppointmentCard = styled('div')<{ top: string; height: string; bgColor?: string }>`
  position: absolute;
  top: ${({ top }) => top};
  left: 2px;
  right: 2px;
  min-height: 20px;
  height: ${({ height }) => height};
  background: ${({ bgColor }) => bgColor || '#818cf8'};
  color: #fff;
  border-radius: 6px;
  padding: 2px 6px;
  font-size: 11px;
  overflow: hidden;
  cursor: pointer;
  z-index: 1;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    opacity: 0.92;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  }
`

export const CardTime = styled('div')`
  font-weight: 600;
  font-size: 14px;
`

export const CardTitle = styled('div')`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
    font-size: 14px;
`

export const EmptyHeaderCell = styled('div')`
  position: sticky;
  left: 0;
  z-index: 3;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
`
